import Enum from "../../../../class/Enum";

const Commercialization = Enum.make({
	withOrders:	"WITH_ORDERS",
	// "WITHOUT_ORDERS", // use empty payment means for the mean while
	withoutPrices: "WITHOUT_PRICES",
});

export default Commercialization;
